/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".flex-div[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center;height:73vh}.plan-contract-btn[_ngcontent-%COMP%]{background-color:#3d8b59;border-radius:25px;color:#fff;padding:15px 30px}.plan-header-amount[_ngcontent-%COMP%]{font-size:1.5rem;text-align:center;color:#fff}"];
export { styles as styles };
